import React from 'react';
import MUIDataTable from 'mui-datatables';
import { Link } from 'react-router-dom';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import { Avatar, Fade, Button, IconButton, FormControl, Paper, Slide, Typography,
  withStyles, InputLabel, Select, MenuItem, TextField, Checkbox, FormControlLabel } from '@material-ui/core';
import LongMenu from '../share/LongMenu';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { parse, format, subMonths } from 'date-fns';
import Search from '@material-ui/icons/Search';
import { inject, observer } from 'mobx-react';
import FilterBeneficiario from '../share/FilterBeneficiario';
import ToolbarNovo from './ToolbarNovo';
import AlertDialogSlide from '../share/AlertDialogSlide';
import VariantSnackbar from '../share/VariantSnackbar';
import classnames from 'classnames';
import DeleteIcon from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import ReplayIcon from '@material-ui/icons/Replay';
import CheckIcon from '@material-ui/icons/CheckCircle';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AccountBalance from '@material-ui/icons/AccountBalance';

import DividaServDesligadoService from '../../services/DividaServDesligadoService';
import FormDialogBaixas from './FormDialogBaixas';
import FormDialogDividaServDesligado from './FormDialogDividaServDesligado';
import ProcessoService from '../../services/ProcessoService';

const styles = theme => ({
  searchIcon: {
    marginRight: theme.spacing.unit,
  },
  button: {
    margin: theme.spacing.unit,
    marginRight: theme.spacing.unit * 10,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  fontTable: {
    fontSize: 12
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12
  },
  formControlAutoCompleteBenef: {
    margin: theme.spacing.unit,
    minWidth: 300,
  },
  selectTipo: {
    margin: theme.spacing.unit,
    width: 350,
  },
  selectEvento: {
    margin: theme.spacing.unit,
    width: 300,
  },
  formControlAutoCompleteProtocolo: {
    marginLeft: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
    width: 205,
  },
  textFieldFrom: {
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 232,
  },
  textFieldTo: {
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    width: 232,
  },
  tableRowProcessado: {
    backgroundColor: '#d0edf4',
  },
  tableRowCancelado: {
    backgroundColor: '#f2dede',
  },
  iconButton: {
    marginBottom: theme.spacing.unit,
  },
  checkBox: {
    marginLeft: theme.spacing.unit * 2,
  },
  fontTableLink: {
    fontSize: 12,
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline'
  },
});
@inject('aplicacaoStore')
@observer

class DividaServDesligado extends React.Component {
  dividaServDesligadoService = new DividaServDesligadoService();
  processoService = new ProcessoService();
  state = {
    dividas: [],
    numDividaSelected: 0,
    nomesBeneficiarios: [],
    nomesBeneficiariosFiltro: [],
    carteiraSelected: '',
    nomeBeneficiarioSelected: '',
    fetching: false,
    fetchingInicio: true,
    eventos: [],
    codEventoSelected: 0,
    tipos: [],
    anosProcessos: [],
    codTipoSelected: 0,
    from: format(subMonths(new Date(), 96), 'YYYY-MM-DD'),
    to: format(new Date(), 'YYYY-MM-DD'),
    dividaSelecionada: {},
    isEditavel: true,
    modoInclusao: true,
    dialogTitle: '',
    dialogMessage: '',
    dialogTitleCancelamento: '',
    dialogMessageCancelamento: '',
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    openDialogBaixas: false,
    openDialogBaixaAutomatica: false,
    openDialogExclusao: false,
    openDialog: false,
    openDialogCancelamento: false,
    openDialogDesfazerCancelamento: false,
    openDialogCompensacaoCredito: false,
    sucesso: true,
    anchorEl: null,
    apenasSemBaixa: false,
  }

  componentDidMount = async () => {
    await this.consultarNomesBeneficiarios();
    await this.consultarNomesBeneficiariosFiltro();
    await this.consultarEventos();
    await this.consultarTipos();
    await this.consultarAnosProcessos();
    this.setState({fetchingInicio: false});
  }
  consultarEventos = async () => {
    let eventos = await this.props.aplicacaoStore.getEventosDividas();
    this.setState({ eventos: eventos });
  }

  consultarTipos = async () => {
    let tipos = await this.props.aplicacaoStore.getTiposDividas();
    this.setState({ tipos: tipos });
  }

  consultarNomesBeneficiarios = async () => {
    const nomesBeneficiarios = await this.props.aplicacaoStore.getServidoresDesligados();
    this.setState({ nomesBeneficiarios: nomesBeneficiarios });
  }

  consultarNomesBeneficiariosFiltro = async () => {
    const nomesBeneficiariosFiltro = await this.props.aplicacaoStore.getBeneficiarios();
    this.setState({ nomesBeneficiariosFiltro: nomesBeneficiariosFiltro });
  }

  consultarAnosProcessos = async () => {
    let anosProcessos = await this.processoService.consultarAnosProcessos();
    this.setState({anosProcessos: anosProcessos});
  }

  handleClickBuscar = async () => {
    this.setState({acertos: [], fetching: true});
    const filtro = {
      numMatricula: this.state.carteiraSelected !== '' ? this.state.carteiraSelected : 'vazio',
      codEvento: this.state.codEventoSelected,
      codTipo: this.state.codTipoSelected,
      dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
      dataFinal: this.state.to === '' ? parse(new Date()) : parse(this.state.to),
    };
    await this.consultarDividas(filtro);
    this.setState({fetching: false});
  }
  consultarDividas = async (filtro) => {
    this.setState({dividas: [], fetching: true});
    const dividas = await this.dividaServDesligadoService.consultarDividas(filtro.numMatricula, filtro.codEvento, filtro.codTipo, filtro.dataInicial, filtro.dataFinal, this.state.apenasSemBaixa === false ? 0 : 1);
    this.setState({ dividas: dividas, fetching: false });
  }

  handleClickLimpar = async () => {
    this.setState({
      carteiraSelected: '',
      nomeBeneficiarioSelected: ''
    });
  }

  handleSelectBeneficiario = (carteira, nome) => {
    this.setState({
      carteiraSelected: carteira,
      nomeBeneficiarioSelected: nome
    });
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleClickBaixa = (event) => {
    const dividaSelecionada = {
      numDivida: event.rowData[0],
      baixas: event.rowData[16],
    };
    this.setState({openDialogBaixas: true, dialogTitle: 'Baixas da Dívida - ' + dividaSelecionada.numDivida, dividaSelecionada: dividaSelecionada});
  }

  handleDialogCloseBaixas = async () => {
    await this.setState({openDialogBaixas: false});
  };
  handleDialogCloseBaixaAutomatica = async () => {
    await this.setState({openDialogBaixaAutomatica: false});
  };  
  handleDialogCloseCompensacaoCredito = async () => {
    await this.setState({openDialogCompensacaoCredito: false});
  };    
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }
  handleClickIncluir = () => {
    this.setState({openDialog: true, dialogTitle: 'Inclusão de Dívida', dividaSelecionada: {}, modoInclusao: true, isEditavel: true});
  }
  handleDialogClose = async () => {
    await this.setState({openDialog: false});
  };
  handleChangeMenu = (index) => {
    this.setState({anchorEl: null});
    if (index === 0) {
      // if (Number(this.state.dividaSelecionada.valTotalBaixado.replace('.', '').replace(',', '.')) === 0) {
        this.setState({openDialogExclusao: true, dialogTitle: 'Exclusão da Dívida - ' + this.state.dividaSelecionada.numDivida, dialogMessage: 'Deseja excluir esta dívida?'});    
      // } else {
      //   this.setState({snackOpen: true, snackMessage: 'Não foi possível excluir esta dívida pois esta já foi baixada.', fetching: false, sucesso: false});
      // }
    }
    if (index === 1) {
      // if (Number(this.state.dividaSelecionada.valTotalBaixado.replace('.', '').replace(',', '.')) === 0) {
        this.setState({openDialog: true, dialogTitle: 'Alteração da Dívida - ' + this.state.dividaSelecionada.numDivida, modoInclusao: false, isEditavel: true});
      // } else {
      //   this.setState({snackOpen: true, snackMessage: 'Não foi possível alterar esta dívida pois esta já foi baixada.', fetching: false, sucesso: false});
      // }
    }
    if (index === 2) {
      if (Number(this.state.dividaSelecionada.valTotalBaixado.replace('.', '').replace(',', '.')) !== 0) {
        this.setState({openDialogBaixas: true, dialogTitle: 'Baixas da Dívida - ' + this.state.dividaSelecionada.numDivida});
      } else {
        this.setState({snackOpen: true, snackMessage: 'Esta dívida não possui baixas...', fetching: false, sucesso: false});
      }
    }
    if (index === 3) {
      if (Number(this.state.dividaSelecionada.valTotalBaixado.replace('.', '').replace(',', '.')) === 0 && this.state.dividaSelecionada.codTipo !== 1) {
        if (Number(this.state.dividaSelecionada.valDivida.replace('.', '').replace(',', '.')) > 0) {
          this.setState({openDialogBaixaAutomatica: true, dialogTitle: 'Baixa da Dívida - ' + this.state.dividaSelecionada.numDivida, dialogMessage: 'Deseja realizar a baixa automática desta dívida? Esta operação não poderá ser desfeita.'});
        } else {
          this.setState({snackOpen: true, snackMessage: 'Esta dívida não pode ser baixada automaticamente por se tratar de um crédito. Favor realizar a compensação automática.', fetching: false, sucesso: false});          
        }
      } else {
        this.setState({snackOpen: true, snackMessage: 'Esta dívida já foi baixada, ou não pode ser baixada automaticamente por ser de Pagamento Normal...', fetching: false, sucesso: false});
      }
    }
    if (index === 4) {
      if (Number(this.state.dividaSelecionada.valDivida.replace('.', '').replace(',', '.')) < 0 && Number(this.state.dividaSelecionada.valDivida.replace('.', '').replace(',', '.')) < Number(this.state.dividaSelecionada.valTotalBaixado.replace('.', '').replace(',', '.'))) {
        this.setState({openDialogCompensacaoCredito: true, dialogTitle: 'Compensação de Crédito - ' + this.state.dividaSelecionada.numDivida, dialogMessage: 'Deseja realizar a compensação automática deste crédito? Esta operação não poderá ser desfeita.'});
      } else {
        if (Number(this.state.dividaSelecionada.valDivida.replace('.', '').replace(',', '.')) >= 0){
          this.setState({snackOpen: true, snackMessage: 'Esta dívida não se trata de um crédito para o beneficiário, logo não pode ser compensada', fetching: false, sucesso: false});
        }
        if (Number(this.state.dividaSelecionada.valDivida.replace('.', '').replace(',', '.')) >= Number(this.state.dividaSelecionada.valTotalBaixado.replace('.', '').replace(',', '.'))){
          this.setState({snackOpen: true, snackMessage: 'Este crédito já foi compensado', fetching: false, sucesso: false});
        }
      }
    }
  }
  handleClickMenu = (event, tableMeta) => {
    const nf = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });        
    const dividaSelecionada = {
      numDivida: this.state.dividas[tableMeta.rowIndex][0],
      seqBeneficiario: this.state.dividas[tableMeta.rowIndex][1],
      seqDependente: this.state.dividas[tableMeta.rowIndex][2],
      numMatricula: this.state.dividas[tableMeta.rowIndex][3],
      nomeBeneficiario: this.state.dividas[tableMeta.rowIndex][4],
      codEvento: this.state.dividas[tableMeta.rowIndex][5],
      desEvento: this.state.dividas[tableMeta.rowIndex][6],
      codTipo: this.state.dividas[tableMeta.rowIndex][7],
      desTipo: this.state.dividas[tableMeta.rowIndex][8],
      dtaCadastro: this.state.dividas[tableMeta.rowIndex][9],
      valDivida: nf.format(this.state.dividas[tableMeta.rowIndex][10]),
      txtObservacao: this.state.dividas[tableMeta.rowIndex][11],
      dtaCancelamento: this.state.dividas[tableMeta.rowIndex][12],
      txtMotivoCancelamento: this.state.dividas[tableMeta.rowIndex][13],
      codUsuarioCancelamento: this.state.dividas[tableMeta.rowIndex][14],
      valTotalBaixado: nf.format(this.state.dividas[tableMeta.rowIndex][15]),
      baixas: this.state.dividas[tableMeta.rowIndex][16],    
      anoProcesso: this.state.dividas[tableMeta.rowIndex][18],    
      numProcesso: this.state.dividas[tableMeta.rowIndex][19],   
      txtProcessoSei: this.state.dividas[tableMeta.rowIndex][20],   
    };
    this.setState({ anchorEl: event.currentTarget, dividaSelecionada: dividaSelecionada });
  }
  handleCloseDialogExcluir = () => {
    this.setState({ openDialogExclusao: false });
  };
  handleDialogConfirmExcluir = async () => {
    this.setState({ openDialogExclusao: false, fetching: true });
    await this.excluirDivida();
  }
  handleDialogConfirmBaixaAutomatica = async () => {
    this.setState({ openDialogBaixaAutomatica: false, fetching: true });
    await this.baixarAutomaticamente();
  }
  handleDialogConfirmCompensacaoCredito = async () => {
    this.setState({ openDialogCompensacaoCredito: false, fetching: true });
    await this.compensarCredito();
  }
  handleClickCancelar = (event, tableMeta) => {
    const dividaSelecionada = {
      numDivida: this.state.dividas[tableMeta.rowIndex][0],
      valTotalBaixado: this.state.dividas[tableMeta.rowIndex][15],
    };
    if (dividaSelecionada.valTotalBaixado === 0) {
      this.setState({openDialogCancelamento: true, dialogTitleCancelamento: 'Cancelamento de Dívida - ' + dividaSelecionada.numDivida, dialogMessageCancelamento: 'Deseja cancelar esta Dívida? Favor informar o motivo do cancelamento:', modoCancelamento: true, dividaSelecionada: dividaSelecionada});
    } else {
      this.setState({snackOpen: true, snackMessage: 'Não foi possível cancelar esta dívida pois esta já foi baixada.', fetching: false, sucesso: false});
    }
}
  handleClickDesfazerCancelamento = (event, tableMeta) => {
    const dividaSelecionada = {
      numDivida: this.state.dividas[tableMeta.rowIndex][0],
      valTotalBaixado: this.state.dividas[tableMeta.rowIndex][15],
    };
    if (dividaSelecionada.valTotalBaixado === 0) {
      this.setState({openDialogDesfazerCancelamento: true, dialogTitleCancelamento: 'Desfazer Cancelamento - ' + dividaSelecionada.numDivida, dialogMessageCancelamento: 'Deseja desfazer o cancelamento desta Dívida?', modoCancelamento: false, dividaSelecionada: dividaSelecionada});
    } else {
      this.setState({snackOpen: true, snackMessage: 'Não foi possível desfazer o cancelamento desta dívida pois esta já foi baixada.', fetching: false, sucesso: false});
    }
  }
  handleCloseDialogCancelamento = () => {
    this.setState({ openDialogCancelamento: false, openDialogDesfazerCancelamento: false });
  };
  handleDialogConfirmCancelamento = async (motivoCancelamento) => {
    this.setState({ openDialogCancelamento: false, openDialogDesfazerCancelamento: false, fetching: true });
    if (this.state.modoCancelamento) {
      await this.cancelarDivida(motivoCancelamento);
    } else {
      await this.desfazerCancelamentoDivida();
    }
  }
  handleChangeApenasSemBaixa = event => {
    this.setState({ apenasSemBaixa: !this.state.apenasSemBaixa });
  }
  incluirDivida = async (divida) => {
    this.setState({fetching: true, dividaSelecionada: {}});
    const result = await this.dividaServDesligadoService.incluirDivida(divida);
    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {
      await this.setState({numDividaSelected: Number(result.data.registrosSemErros[0])});
    } else {
      await this.setState({numDividaSelected: 0});
    }
    await this.onOperacaoFinalizadaIncluirAlterar(result);
  }
  alterarDivida = async (divida) => {
    this.setState({fetching: true, dividaSelecionada: {}});
    const result = await this.dividaServDesligadoService.alterarDivida(divida);
    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {
      await this.setState({numDividaSelected: Number(result.data.registrosSemErros[0])});
    } else {
      await this.setState({numDividaSelected: 0});
    }
    await this.onOperacaoFinalizadaIncluirAlterar(result);
  }
  excluirDivida = async () => {
    this.setState({fetching: true});
    await this.dividaServDesligadoService.excluirDivida(this.state.dividaSelecionada.numDivida);
    await this.onOperacaoFinalizada('Dívida excluída com sucesso!');
  }
  cancelarDivida = async (motivoCancelamento) => {
    this.setState({fetching: true});
    await this.dividaServDesligadoService.cancelarDivida(this.state.dividaSelecionada.numDivida, motivoCancelamento);
    await this.onOperacaoFinalizada('Dívida cancelada com sucesso!');
  }

  desfazerCancelamentoDivida = async () => {
    this.setState({fetching: true});
    await this.dividaServDesligadoService.desfazerCancelamentoDivida(this.state.dividaSelecionada.numDivida);
    await this.onOperacaoFinalizada('Cancelamento desfeito com sucesso!');
  }
  baixarAutomaticamente = async () => {
    this.setState({fetching: true});
    this.state.dividaSelecionada.valDivida = this.state.dividaSelecionada.valDivida.replace('.', '').replace(',', '.');
    this.state.dividaSelecionada.valTotalBaixado = this.state.dividaSelecionada.valTotalBaixado.replace('.', '').replace(',', '.');
    await this.dividaServDesligadoService.baixarAutomaticamente(this.state.dividaSelecionada);
    await this.onOperacaoFinalizada('Dívida baixada com sucesso!');
  }
  compensarCredito = async () => {
    this.setState({fetching: true});
    var errorMessage = '';
    this.state.dividaSelecionada.valDivida = this.state.dividaSelecionada.valDivida.replace('.', '').replace(',', '.');
    this.state.dividaSelecionada.valTotalBaixado = this.state.dividaSelecionada.valTotalBaixado.replace('.', '').replace(',', '.');
    errorMessage = await this.dividaServDesligadoService.compensarCredito(this.state.dividaSelecionada);
    if (errorMessage.data === '') {
      await this.onOperacaoFinalizada('Crédito compensado com sucesso!');
    } else {
      this.setState({snackOpen: true, snackMessage: errorMessage.data, sucesso: false, fetching: false});
    }        
  }  
  onOperacaoFinalizada = async (msg) => {
    this.setState({fetching: false, snackOpen: true, snackMessage: msg, sucesso: true});
    const filtro = {
      numMatricula: this.state.carteiraSelected !== '' ? this.state.carteiraSelected : 'vazio',
      codEvento: this.state.codEventoSelected,
      codTipo: this.state.codTipoSelected,
      dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
      dataFinal: this.state.to === '' ? parse(new Date()) : parse(this.state.to),
    };
    await this.consultarDividas(filtro);
  }
  onOperacaoFinalizadaIncluirAlterar = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. Favor tentar novamente.',
        fetching: false,
        openDialog: false,
        sucesso: false});
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({ snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          sucesso: true,
          fetching: false,
          openDialog: false });
        event.preventDefault();
        const filtro = {
          numMatricula: this.state.carteiraSelected !== '' ? this.state.carteiraSelected : 'vazio',
          codEvento: this.state.codEventoSelected,
          codTipo: this.state.codTipoSelected,
          dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
          dataFinal: this.state.to === '' ? parse(new Date()) : parse(this.state.to),
        };
        await this.consultarDividas(filtro);
        await this.setState({numDividaSelected: 0});
      } else {
        this.setState({
          openDialogValidacao: true,
          openDialog: false,
          dialogContent: result.data.registrosComErros,
          dialogTitle: result.data.msgRetornoResumida,
          registrosSemErros: result.data.registrosSemErros,
          fetching: false});
      }
    }
  }
  render () {
    const options = {
      setRowProps: (row) => {
        return {          
          title: row[14].trim() !== '' ? 'Registro Cancelado por ' + row[14].trim() + ' em ' + row[12].props.children + ' MOTIVO: ' + row[13] : '',
          className: classnames(
            {
              [this.props.classes.tableRowCancelado]: row[14].trim() !== '',
              [this.props.classes.tableRowProcessado]: Number(row[15].props.children.substring(3,row[15].props.children.length).replace('.', '').replace(',', '.')) !== 0 &&
              row[14].trim() === '' &&
              Number(row[15].props.children.substring(3,row[15].props.children.length).replace('.', '').replace(',', '.')) >= Number(row[10].props.children.substring(3,row[10].props.children.length).replace('.', '').replace(',', '.')),
            }, this.props.classes.tableRow),
        };
      },
      customToolbar: () => (
        <ToolbarNovo
          handleClickIncluir={this.handleClickIncluir}
        />
      ),
      print: false,
      download: false,
      filterType: 'dropdown',
      selectableRows: false,
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline'}}>registro(s) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Num. Dívida',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'seqBeneficiario',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'seqDependente',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Carteira',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'codEvento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Evento',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'codTipo',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Tipo',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Data Cadastro',
        options: {
          // display: 'excluded',
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Valor Dívida',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Observacao',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value.trim() === '' ? '-' : value}</Typography>;
          },
        }
      },
      {
        name: 'dtaCancelamento',
        options: {
          display: 'excluded',
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'txtMotivoCancelamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'codUsuarioCancelamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Valor Baixado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return value !== 0
            ? <Typography
              className={classes.fontTableLink}
              title='Clique no link para detalhar as baixas...'
              onClick={() => this.handleClickBaixa(tableMeta)}>
                {nf.format(value)}
              </Typography>
            : <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'baixas',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Cancelamento',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              value === 'CANCELAR'
                ? <IconButton
                  id={'menuButton'}
                  className={classes.iconButton}
                  aria-label='More'
                  aria-owns={open ? 'long-menu' : null}
                  aria-haspopup='true'
                  title={'Cancelar o Acerto'}
                  onClick={event => this.handleClickCancelar(event, tableMeta)}
                >
                  <ClearIcon fontSize='default' />
                </IconButton>
                : value === 'DESFAZER'
                  ? <IconButton
                    id={'menuButton'}
                    className={classes.iconButton}
                    aria-label='More'
                    aria-owns={open ? 'long-menu' : null}
                    aria-haspopup='true'
                    title={'Desfazer o Cancelamento'}
                    onClick={event => this.handleClickDesfazerCancelamento(event, tableMeta)}
                  >
                    <ReplayIcon fontSize='default' />
                  </IconButton>
                  : '-'
            );
          },
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            let options = [
              {
                index: 0,
                icon: <DeleteIcon />,
                primaryText: 'Excluir Dívida...',
                visible: true,
                disabled: false
              },
              {
                index: 1,
                icon: <Edit />,
                primaryText: 'Alterar Dívida...',
                visible: true,
                disabled: false
              },
              {
                index: 2,
                icon: <VisibilityIcon />,
                primaryText: 'Ver Baixas...',
                visible: true,
                disabled: false
              },
              {
                index: 3,
                icon: <CheckIcon />,
                primaryText: 'Baixar Automaticamente...',
                visible: true,
                disabled: false
              },
              {
                index: 4,
                icon: <AccountBalance />,
                primaryText: 'Compensar Crédito...',
                visible: true,
                disabled: false
              },
            ];
            return (
              <LongMenu
                menuOptions={options}
                anchorEl={this.state.anchorEl}
                handleClick={this.handleClickMenu}
                handleChange={this.handleChangeMenu}
                handleClose={this.handleCloseMenu}
                selectedItem={tableMeta} />
            );
          },
        }
      },
      {
        name: 'anoProcesso',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'numProcesso',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'txtProcessoSei',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
    ];
    const { classes } = this.props;
    const { fetching, fetchingInicio, dividas,
      eventos, codEventoSelected,
      tipos, codTipoSelected,
      from, to } = this.state;
    return (
      <React.Fragment>
        <Link to='/financeiro' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Dívidas de Servidores Desligados</Typography>
              <Avatar className={classes.avatar}>{dividas.length}</Avatar>
            </Paper>
          </Slide>
        </Link>
        {fetchingInicio ? <LinearProgressBlockScreen />
          : <Paper className={classes.body} elevation={1}>
            <FormControl component='filedset' className={classes.formControlAutoCompleteBenef}>
              <FilterBeneficiario
                beneficiarios={this.state.nomesBeneficiariosFiltro}
                handleSelectBeneficiario={this.handleSelectBeneficiario}
                handleClickLimpar={this.handleClickLimpar} />
            </FormControl>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectEvento}>
                Evento
              </InputLabel>
              <Select
                className={classes.selectEvento}
                value={codEventoSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codEventoSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODOS</MenuItem>
                {eventos.map((evento, idx) => {
                  return (<MenuItem key={idx} value={evento.id}>{evento.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectTipo}>
                Tipo
              </InputLabel>
              <Select
                className={classes.selectTipo}
                value={codTipoSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTipoSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODOS</MenuItem>
                {tipos.map((tipo, idx) => {
                  return (<MenuItem key={idx} value={tipo.id}>{tipo.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <FormControl>
              <Button
                variant='extendedFab'
                title='Buscar'
                type='submit'
                onClick={this.handleClickBuscar}
                onTouchStart={this.handleClickBuscar}
                className={classes.button}>
                <Search className={classes.searchIcon} />
                Buscar
              </Button>
            </FormControl>
            <TextField
              id='date'
              label='De'
              type='date'
              value={from}
              onChange={this.handleChange}
              inputProps={{
                name: 'from',
              }}
              className={classes.textFieldFrom}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id='date'
              label='Até'
              className={classes.textFieldTo}
              type='date'
              value={to}
              onChange={this.handleChange}
              inputProps={{
                name: 'to',
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.apenasSemBaixa}
                  onChange={this.handleChangeApenasSemBaixa}
                  name='apenasSemBaixa'
                />
              }
              label='Apenas sem Baixa?'
            />
          </Paper>
        }
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={dividas}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>}
          {this.state.openDialogBaixas &&
          <FormDialogBaixas
            titulo={this.state.dialogTitle}
            baixas={this.state.dividaSelecionada.baixas}
            open={this.state.openDialogBaixas}
            handleClose={this.handleDialogCloseBaixas}/>}
        {this.state.openDialog &&
          <FormDialogDividaServDesligado
            titulo={this.state.dialogTitle}
            divida={this.state.dividaSelecionada}
            nomesBeneficiarios={this.state.nomesBeneficiarios}
            anosProcessos={this.state.anosProcessos}
            eventos={this.state.eventos}
            tipos={this.state.tipos}
            open={this.state.openDialog}
            modoInclusao={this.state.modoInclusao}
            isEditavel={this.state.isEditavel}
            handleClose={this.handleDialogClose}
            handleSave={this.state.modoInclusao ? this.incluirDivida : this.alterarDivida} />}
        <AlertDialogSlide
          open={this.state.openDialogExclusao}
          handleClose={this.handleCloseDialogExcluir}
          handleClick={this.handleDialogConfirmExcluir}
          title={this.state.dialogTitle}
          message={this.state.dialogMessage} />
        <AlertDialogSlide
          open={this.state.openDialogCancelamento}
          handleClose={this.handleCloseDialogCancelamento}
          handleClick={this.handleDialogConfirmCancelamento}
          title={this.state.dialogTitleCancelamento}
          editavel
          message={this.state.dialogMessageCancelamento} />
        <AlertDialogSlide
          open={this.state.openDialogDesfazerCancelamento}
          handleClose={this.handleCloseDialogCancelamento}
          handleClick={this.handleDialogConfirmCancelamento}
          title={this.state.dialogTitleCancelamento}
          message={this.state.dialogMessageCancelamento} />
        <AlertDialogSlide
          open={this.state.openDialogBaixaAutomatica}
          handleClose={this.handleDialogCloseBaixaAutomatica}
          handleClick={this.handleDialogConfirmBaixaAutomatica}
          title={this.state.dialogTitle}
          message={this.state.dialogMessage} />
        <AlertDialogSlide
          open={this.state.openDialogCompensacaoCredito}
          handleClose={this.handleDialogCloseCompensacaoCredito}
          handleClick={this.handleDialogConfirmCompensacaoCredito}
          title={this.state.dialogTitle}
          message={this.state.dialogMessage} />
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(DividaServDesligado);
